import { FormikValues, useFormikContext } from "formik";
import { isArray } from "lodash";

import { bemClassName } from "../../utils/bemClassName";
import { joinClassNames } from "../../utils/joinClassNames";
import { nonFacetSearchParams } from "./nonFacetSearchParams";
import { useSearchParams } from "react-router-dom";
import { showAllQuery, useSearchQuestion } from "../../context/DataContext";

import styles from "./Facets.module.css";

const composeClearedFormikValues = (formValues: FormikValues): FormikValues => {
    // Preserve query value
    const { query } = formValues;

    // Clear facet values
    const clearedFacets: FormikValues = {};
    Object.entries(formValues).forEach(([fieldKey, fieldValue]) => {
        if (isArray(fieldValue)) {
            clearedFacets[fieldKey] = [];
        } else {
            clearedFacets[fieldKey] = "";
        }
    });

    const clearedValues = {
        query,
        ...clearedFacets,
    };
    return clearedValues;
};

export const FacetsClearButton = () => {
    const { clearFilters } = useSearchQuestion();
    const [searchParams, setSearchParams] = useSearchParams();
    const { setFieldValue, values } = useFormikContext() as FormikValues;

    const handleClick = () => {
        // Request new data from Funnelback
        clearFilters();

        const clearedValues = composeClearedFormikValues(values);
        // Set form state
        Object.entries(clearedValues).forEach(([fieldKey, fieldValue]) => {
            setFieldValue(fieldKey, fieldValue);
        });

        // Set URL search params
        const clearedUrlSearchParams = new URLSearchParams();
        // Preserve non-facet URL search params
        nonFacetSearchParams.forEach((paramConfig) => {
            const { paramKey } = paramConfig;
            if (paramKey === "query") {
                const fieldValue: string = values.query.trim();
                const newParamValue = fieldValue ? fieldValue : showAllQuery;
                clearedUrlSearchParams.set(paramKey, newParamValue);
            } else {
                const currentSearchParamValue = searchParams
                    .get(paramKey)
                    ?.trim();
                if (currentSearchParamValue) {
                    clearedUrlSearchParams.set(
                        paramKey,
                        currentSearchParamValue
                    );
                }
            }
        });
        setSearchParams(clearedUrlSearchParams);
    };

    return (
        <button
            type="button"
            className={joinClassNames([
                bemClassName("find-a-panel", "clear-all"),
                styles.clear,
            ])}
            onClick={handleClick}
        >
            <svg
                viewBox="0 0 24 24"
                aria-hidden="true"
                overflow="visible"
                className={bemClassName("find-a-panel", "clear-icon")}
            >
                <path d="M12 0C5.371 0 0 5.371 0 12s5.371 12 12 12 12-5.371 12-12S18.629 0 12 0zm5.884 15.15a.581.581 0 010 .823l-1.916 1.91a.581.581 0 01-.823 0L12 14.71l-3.15 3.174a.581.581 0 01-.823 0l-1.91-1.916a.581.581 0 010-.823L9.29 12 6.116 8.85a.581.581 0 010-.823l1.916-1.916a.581.581 0 01.823 0L12 9.291l3.15-3.175a.581.581 0 01.823 0l1.916 1.916a.581.581 0 010 .823L14.709 12l3.175 3.15z"></path>
            </svg>
            Clear search filters
        </button>
    );
};

export default FacetsClearButton;
